import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { AppLayout } from "../../../components/app/AppLayout";
import { AppThemeProvider } from "../../../components/app/ThemeProvider";
import { CoachAcceptInviteScreen } from "../../../components/auth/CoachAcceptInviteScreen";
import { LoadingPage } from "../../../components/loading/LoadingPage";
import useAuth from "../../../hooks/auth/useAuth";
import TeamService from "../../../services/TeamService";
import { REQUIRE_LOGOUT_ROUTE } from "../../routes";

export const SIGNUP_COACH_VERIFY_INVITE_QUERY_KEY =
  "signup-coach-verify-invite";

export function SignUpCoachRoute() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { authorized } = useAuth();

  const oobCode = searchParams.get("oobCode");
  const id = searchParams.get("id");
  const email = searchParams.get("email");
  const requestWorkspace = searchParams.get("workspace");

  const { data: workspace, isLoading } = useQuery({
    queryKey: [SIGNUP_COACH_VERIFY_INVITE_QUERY_KEY],
    queryFn: async () => {
      return TeamService.getInvitedWorkspace(
        id ?? "",
        requestWorkspace ?? "",
        email,
      );
    },
    enabled: !!id && !!requestWorkspace && !authorized,
  });

  if (authorized) {
    return (
      <Navigate to={REQUIRE_LOGOUT_ROUTE} state={{ from: location }} replace />
    );
  }

  return (
    <>
      {isLoading ? (
        <LoadingPage />
      ) : workspace ? (
        <AppLayout title="Sign Up" appBar={false}>
          <AppThemeProvider workspace={workspace}>
            <CoachAcceptInviteScreen
              workspace={workspace}
              code={oobCode}
              email={email}
            />
          </AppThemeProvider>
        </AppLayout>
      ) : (
        <AppLayout title="Sign Up" appBar={false}>
          <Box>
            Invalid invite. Please contact the person who invited you to the
            team.
          </Box>
        </AppLayout>
      )}
    </>
  );
}

export default SignUpCoachRoute;
